import { render, staticRenderFns } from "./addTrainUsersModal.vue?vue&type=template&id=394a302e&scoped=true&"
import script from "./addTrainUsersModal.vue?vue&type=script&lang=js&"
export * from "./addTrainUsersModal.vue?vue&type=script&lang=js&"
import style0 from "./addTrainUsersModal.vue?vue&type=style&index=0&id=394a302e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a302e",
  null
  
)

export default component.exports